module.exports = __webpack_public_path__ + "img/02.33456e8b.jpg";